// extracted by mini-css-extract-plugin
export var cursor = "CursorProvider-module--cursor--2-0nB";
export var inner = "CursorProvider-module--inner--1Za2P";
export var expanded = "CursorProvider-module--expanded--3u6_q";
export var scaleAnimation = "CursorProvider-module--scaleAnimation--34hwe";